class ConstPerfilesCliente
{
  PERFILA = "0001";
  COMPRAS = "0002";
  PERFILB = "0003";
  CREDITO = "0005";
  CALIDAD = "0007";
  PERFILC = "0009";
  ALMACEN = "0011";

  constructor(obj = {}) {
    Object.assign(this, obj);
  }
}

module.exports = ConstPerfilesCliente;